import { DEFAULT_PAGINATION } from "constants/defaultPagination";

import { useGetAccountsQuery } from "../api/Accounts";
import { DEFAULT_PAGINATION_CONFIGURATION } from "../constants/DefaultPaginationConfiguration";

import type { UUID } from "utils";
import type { PaginationParams } from "../../../utils/preparePaginationParams";
import type { OrderableColumns } from "../constants/Account";

type UseAccountsArgs = Partial<PaginationParams<OrderableColumns>> & {
  customerId?: UUID | UUID[];
  skip?: boolean;
};

export function useAccounts({
  customerId,
  skip,
  ...pagination
}: UseAccountsArgs) {
  const {
    order: { defaultValue: order },
    orderBy: { defaultValue: sortBy },
  } = DEFAULT_PAGINATION_CONFIGURATION;

  const { data, isError, isLoading, isFetching, refetch } = useGetAccountsQuery(
    {
      customer: customerId,
      ...DEFAULT_PAGINATION,
      order,
      sortBy,
      ...pagination,
    },
    { skip }
  );

  return {
    accounts: data?.accounts ?? [],
    totalItems: data?.totalItems ?? 0,
    isError,
    isLoading,
    isFetching,
    refetch,
  };
}
